  <div class="glassy-table card-nav-tabs mt-0 rounded-lg border-0 shadow-lg container p-4">
      <div class="table-responsive mt-2">
        <table id="invoices_table" class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Invoice Number</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Issued</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Due Date</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in invoices" :key="invoice.id">
              <td class="text-xxs text-start">{{ invoice.invoice_number }}</td>
              <td class="text-xxs text-start">{{ invoice.invoice_status.code }}</td>
              <td class="text-xxs text-start">{{ invoice.date_issued }}</td>
              <td class="text-xxs text-start">{{ invoice.due_date }}</td>
              <td class="text-xxs text-start">{{ this.format_date(invoice.date_created) }}</td>
              <td>
                  <button
                    class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs mb-1"
                    data-bs-toggle="modal"
                    data-bs-target="#preview_invoice_items"
                    @click="get_invoice_details(invoice.id)">
                    Preview Accepted Items
                  </button>

                   <button
                    class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs mb-1"
                    data-bs-toggle="modal"
                    data-bs-target="#preview_invoice_overview"
                    @click="preview_invoice(invoice)">
                    Preview invoice
                  </button>
                  <button
                    class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs mb-1"
                    @click="view_payment(invoice)"
                  >
                    View POP
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>

<!-- View invoice details -->
<teleport to="body">
  <div class="modal fade" id="preview_invoice_items" tabindex="-1" aria-labelledby="view_invoice_label"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Service Selection -->
          <div class="mx-4 mb-4">
            <!-- Main Service Card -->
            <div class="card border mt-3" v-for="main_service in main_service" :key="main_service.id">
              <div class="card-body p-0">
                <!-- Service Selection Row -->
                <div class="d-flex align-items-center p-3 border-bottom bg-light">
                  <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                    <div>
                      <p class="fw-bold mb-0 text-dark text-xs ">{{ main_service.name }}</p>
                    </div>
                    <div class="text-end">
                      <div class="fw-bold mb-0 text-dark text-xs ">{{ format_currency(main_service.total) }}</div>
                    </div>
                  </div>
                  <div class="ms-3">
                    <button class="btn btn-sm btn-outline-secondary d-flex align-items-center" type="button"
                      @click="toggle_accordion(main_service.id)"
                      :aria-expanded="openAccordions.includes(main_service.id)">
                      <span class="me-2 text-xs">
                        {{ openAccordions.includes(main_service.id) ? 'Hide' : 'Show' }} Details
                      </span>
                      <!-- svg icon -->
                    </button>
                  </div>
                </div>

                <!-- Expandable Details -->
                <div v-show="openAccordions.includes(main_service.id)" class="border-top">
                  <div class="p-3 bg-white">
                    <p class="text-muted mb-3 text-xs">What's included in {{ main_service.name }}:</p>
                    <div class="row">
                      <div class="col-12">
                        <ul class="list-unstyled mb-0">
                          <li v-for="subService in main_service.sub_services" :key="subService.id"
                            class="mb-2 d-flex align-items-center">
                            <div class="me-3">
                              <div class=" d-flex align-items-center justify-content-center">
                                <svg width="12" height="12" fill="white">
                                  <path d="M3.5 7l2 2 5-5" stroke="currentColor" stroke-width="2" fill="none" />
                                </svg>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div class="text-xs">{{ subService.name }}</div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

 <!-- View invoice PDF -->
  <teleport to="body">
    <div class="modal fade" id="preview_invoice_overview" tabindex="-1" aria-labelledby="previewInvoiceLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="previewInvoiceLabel">Invoice Preview</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <div class="ratio ratio-4x3">
            <iframe
                v-if="preview_invoice_url"
                id="preview_invoice_iframe"
                class="embed-responsive-item"
                :src="preview_invoice_url"
                frameborder="0">
              </iframe>
            <div v-else class="d-flex align-items-center justify-content-center w-100 h-100">
              No preview available.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
              <div class="col">
                  <div  v-if="invoice_status !== 'Sent'"
                    class="alert alert-warning alert-dismissible fade show text-center" role="alert">
                      <strong>Note:</strong> Once the invoice is generated, no further changes can be made.
                      Please take a moment to review the items added before proceeding with the invoice generation.
                  </div>
                  <div  v-else
                    class="alert alert-warning alert-dismissible fade show text-center" role="alert">
                      <strong>Note:</strong> Invoice already sent.
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col">
                <button
                  v-if="invoice_status !== 'Sent'"
                  class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                  @click="send_invoice()">
                  Send invoice
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>